import React, { FC } from 'react';
import { IconButton } from '@mui/material';
import { HeaderBadge } from '@styles/Layout/HeaderStyles';

interface IHeaderControlButtonProps {
  icon: FC<React.ComponentProps<'svg'>>;
  count?: number;

  onClick(event: React.MouseEvent<HTMLButtonElement>): void;
}

export const HeaderControlButton = ({ count, onClick, icon: IconComponent }: IHeaderControlButtonProps) => (
  <IconButton onClick={onClick}>
    <HeaderBadge badgeContent={count} color="primary">
      <IconComponent width={24} color={'#5C5C5C'} />
    </HeaderBadge>
  </IconButton>
);
